export class ShortcutEvent  {
    shortcut: string;
}